const isAdmin = (account) => {
  const currentOrganization = account?.account?.currentOrganization;
  return currentOrganization?.role === 'admin';
};

export default { isAdmin };
